// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1uh2U","label":"Radio_label__2X2yq","checkMark":"Radio_checkMark__2aWjt","disabled":"Radio_disabled__1S4Cr"};